import { FC } from 'react'
import { observer } from 'mobx-react-lite'
import cn from 'classnames'

import { Article } from '@/components/Article'
import { ArticleImage } from '@/components/ArticleImage'

import { navigationMenuStore } from '@/store/NavigationMenu'

import styles from './NavigationArticle.module.scss'

interface NavigationArticleProps {
  className?: string
  onOpen: () => void
}
export const NavigationArticle: FC<NavigationArticleProps> = observer(
  ({ onOpen, className }) => {
    if (navigationMenuStore.article == null) {
      return null
    }

    return (
      <div className={cn(styles.container, className)}>
        <Article
          id={navigationMenuStore.article.slug}
          image={
            <ArticleImage
              image={navigationMenuStore.article.thumbnail?.[0]}
              className={styles.image}
            />
          }
          title={navigationMenuStore.article.title}
          publishedAt={navigationMenuStore.article.publishedAt}
          readTime={navigationMenuStore.article.readingTime}
          onClick={onOpen}
        />
      </div>
    )
  }
)
